<template>
  <div class="form-group">
    <label v-if="label"
           :for="id"
           v-bind:class="{required: hasRequired}">
      {{label}}
    </label>
    <div class="custom-file input-group" v-bind:class="{ 'is-invalid': validation.$error }">
      <input type="file"
             v-bind="$attrs"
             class="form-control-file"
             :id="id"
             v-if="inputVisible"
             v-on="domEventListeners"
             ref="file" />
      <label class="custom-file-label" :for="id">
        <span v-if="value">{{value.name}}</span>
        <span v-else-if="file">{{file.name}}</span>
      </label>
    </div>
    <div class="invalid-feedback">
      {{errorMessage}}
    </div>
  </div>
</template>

<script>
import { ValidationMixin } from '@/js/Mixins';

export default {
  name: 'BaseFileUploader',
  props: {
    label: String,
    value: File,
    file: Object,
    inputVisible: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [ValidationMixin],
  data() {
    return {
      id: `filepicker-${this._uid}`,
    };
  },
  computed: {
    domEventListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        change() {
          vm.$emit('input', vm.$refs.file.files[0]);
        },
        input() {
          vm.$emit('input', vm.$refs.file.files[0]);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-file.is-invalid ~ .invalid-feedback
{
    display: block;
}
</style>
